var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-width":"1200px"}},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"fl pt40"},[_c('a',{attrs:{"href":"http://www.hanyuan.gov.cn"}},[_c('img',{attrs:{"src":require("../../assets/img/whiteLogo.png"),"alt":""}})])])])])])
}]

export { render, staticRenderFns }